const assetTypeOptions = [
  {value: "", label: "All"},
  {value: "CONTAINER_CHASSIS", label: "Container/Chassis"},
  {value: "TRUCK_PLUS_CONTAINER_TRAILER", label: "Truck + Container/Trailer"},
  {value: "TRUCK_ONLY", label: "Truck Only"},
  {value: "TRAILER", label: "Trailer"},
  {value: "REEFER", label: "Refrigeration"},
  {value: "EQUIPMENT_MOVING_FEES", label: "Equipment Moving Fee"},
  {value: "GATE_FEES", label: "Gate Fees"},
  {value: "GROUNDED_CONTAINER_FEES", label: "Grounded Container"},
  {value: "LIFT_FEES", label: "Lift Fees"},
  {value: "OVERAGE_FEES",label: "Overage Spaces"},
  {value: "REEFER_FEES", label: "Reefer KW Usage"}
];

const frequencyOptions = [
  {label: 'All', value: ''},
  {label: 'Daily', value: 'ONE_TIME'},
  {label: 'Monthly', value: 'RECURRING'}
];

const BookingStatusGroups = Object.freeze({
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
  FAILED: 'FAILED',
});

const BookingStatusGroupVerbiage = Object.freeze({
  [BookingStatusGroups.ACTIVE]: {
    label: 'Active',
    description: 'An approved booking that is current or in the future.',
  },
  [BookingStatusGroups.PENDING]: {
    label: 'Pending',
    description: 'A booking request that is awaiting supplier approval or buyer to complete the booking.',
  },
  [BookingStatusGroups.INACTIVE]: {
    label: 'Inactive',
    description: 'A booking that is expired, canceled, or declined.',
  },
  [BookingStatusGroups.FAILED]: {
    label: 'Payment Failed',
    description: 'A booking that has failed due to insufficient funds or a bank dispute. The booking cannot be used until the buyer submits payment.',
  },
});

const formatTabHeader = (statusGroup, count) => {
  const label = BookingStatusGroupVerbiage[statusGroup].label || '';
  return count ? `${label} (${count})` : label;
}

export {
  assetTypeOptions,
  frequencyOptions,
  BookingStatusGroups,
  BookingStatusGroupVerbiage,
  formatTabHeader
}